import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const CostCentersListPageImport = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const {
    company,
    access: { locale },
  } = useCurrentSession()

  const handleImport = useUnsafeCallback(() => {}, [])
  const onClose = useUnsafeCallback(() => {
    navigate(navigation.settings.finance.costCenters.list.fullPath())
  }, [navigate, navigation])

  const footer = useUnsafeCallback(() => {
    return (
      <Button onClick={onClose} type="secondary">
        {i18n.t('common.cancel')}
      </Button>
    )
  }, [onClose])

  return (
    <Modal
      disableFocusTrap
      footer={footer()}
      onClose={onClose}
      onSubmit={handleImport}
      illustration="table-file"
      title={i18n.t('finance.cost_centers_list.import.title')}
    >
      <NuvoImporter locale={locale} companyId={company.id} importType="cost_centers_importer" />
    </Modal>
  )
}

export default CostCentersListPageImport
